import { SYNC_LIMIT_LOW } from '@/utilities/constants';

import { BorerStateTypeCategoryDocument } from '../BorerStateTypeCategory/queryBuilder';
import { EquipmentTypeDocument } from '../EquipmentType/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { BorerStateTypeDocument, borerStateTypePullQueryBuilder } from './queryBuilder';

export function borerStateTypeFamilyMember(
  configBuilder: ConfigBuilder,
  borerStateTypeCategory: FamilyMember<BorerStateTypeCategoryDocument>,
  equipmentType: FamilyMember<EquipmentTypeDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerStateTypeDocument> {
  const syncConfig = configBuilder<BorerStateTypeDocument>(RxdbCollectionNameV2.BORER_STATE_TYPE);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, borerStateTypePullQueryBuilder);
  pullConfig.batchSize = SYNC_LIMIT_LOW;

  const replicationState = replicate(syncConfig);
  // Legacy had syncInterval set to LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.BORER_STATE_TYPE, replicationState, [
    borerStateTypeCategory,
    equipmentType,
    sites,
  ]);
}
